import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AllOrder from "../../component/AllOrder";
import axios from 'axios'
import { Auth } from "../../component/Auth";
const OrdersFulfilled = () => {
  const [tData, setTData] = useState([]);
  const [isLoading, setIsLoading] = useState({loading: true, error: false})
  
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order?status=ORDER_DELIVERED`,
      headers: { 
        'Authorization': Auth()
    }
    };

    axios.request(config)
    .then((response) => {
      setTData(response.data)
      setIsLoading({loading: false, error: false})
    })
    .catch((error) => {
      console.log(error);
      setIsLoading({loading: false, error: true})
    });
  },[])

  return (
    <Box p={5} flex="1" w={'100%'}>
      <AllOrder
        title={"Fulfilled Orders"}
        head={["Order", "Date" , "Customer Name", "Total" , "Items", "Order Status" , "Action", ""]}
        data={tData}
        isLoading={isLoading}
      />
    </Box>
  )
};

export default OrdersFulfilled;
